import React, {
  useCallback,
  useMemo,
  useState,
  useRef,
  useEffect,
} from "react";
import moment from "moment-jalaali";
import { useLocation } from "react-router";
import { Line } from "react-chartjs-2";
import { useSelector } from "react-redux";
import Select from "./Select/Select";
import SpinnerHandler from "../../hoc/SpinnerHandler/SpinnerHandler";
// import useHttp from '../../hooks/http';
import useAsync from "../../hooks/asyncRequests";
import Header from "../../Components/UI/Header/Header";
import Footer from "../../Components/UI/Footer/Footer";
import Icon from "@mdi/react";
import { mdiCloudUploadOutline, mdiPageFirst, mdiPageLast } from "@mdi/js";
import "./Charts.scss";
import CInput from "../../Components/UI/CInput/CInput";
import { Compare } from "@mui/icons-material";
import masarefKeshavarziImg from "../../assets/Charts/masaref-keshavarzi.png";
import masarefShorbImg from "../../assets/Charts/masaref-shorb.png";
import masarefSanatImg from "../../assets/Charts/masaref-sanat.png";
import rahasaziLakeImg from "../../assets/Charts/rahasazi-daryache.png";
import totalInputImg from "../../assets/Charts/total-input.png";
import percentFillImg from "../../assets/Charts/percent-fill.png";
import volumeInputImg from "../../assets/Charts/volume_input.png";
import CompareChart from "./CompareChart";
import { Helmet } from "react-helmet";

const lbDic = {
  usage_farming_current_year: "مصارف کشاورزی",
  usage_drinking_current_year: "مصارف شرب",
  usage_industrial_current_year: "مصارف صنعت",
  usage_other_current_year: "رهاسازی دریاچه",
  input_current_year: "مجموع ورودی",
  water_supplied_volume_current_year: "درصد پر بودن",
  volume_current_year: "حجم مخزن",
};

const typeCompare = {
  programCompare: {
    title: "مقایسه با برنامه",
    url: "dam-monthly",
    type: "program",
    labels: [
      "فروردین",
      "اردیبهشت",
      "خرداد",
      "تیر",
      "مرداد",
      "شهریور",
      "مهر",
      "آبان",
      "آذر",
      "دی",
      "بهمن",
      "اسفند",
    ],
  },
  forecastCompare: {
    title: "مقایسه با پیش بینی",
    url: "dam-seasonal",
    type: "forecast",
    labels: ["بهار", "تابستان", "پاییز", "زمستان"],
  },
};

const thisPageData = {
  title: "سد",
  options: [
    {
      value: "حجم مخزن",
      gainValue: "volume_current_year",
      unit: (
        <span>
          m<sup>3</sup>/s
        </span>
      ),
      img: volumeInputImg,
      color: "50, 3, 227",
      comparedName: "",
    },
    {
      value: "درصد پر بودن سد",
      gainValue: "water_supplied_volume_current_year",
      unit: "%",
      img: percentFillImg,
      color: "38, 120, 167",
      comparedName: "",
    },
    {
      value: "مجموع ورودی",
      gainValue: "input_current_year",
      unit: "MCM",
      img: totalInputImg,
      color: "185, 153, 204",
      comparedName: "",
    },
    {
      value: "رها سازی دریاچه",
      gainValue: "usage_other_current_year",
      unit: "MCM",
      img: rahasaziLakeImg,
      color: "1, 177, 237",
      comparedName: "other",
    },
    {
      value: "مصارف صنعت",
      gainValue: "usage_industrial_current_year",
      unit: "MCM",
      img: masarefSanatImg,
      color: "215, 174, 86",
      comparedName: "industrial",
    },
    {
      value: "مصارف شرب",
      gainValue: "usage_drinking_current_year",
      unit: "MCM",
      img: masarefShorbImg,
      color: "152, 209, 236",
      comparedName: "drinking",
    },
    {
      value: "مصارف کشاورزی",
      gainValue: "usage_farming_current_year",
      unit: "MCM",
      img: masarefKeshavarziImg,
      color: "125, 170, 75",
      comparedName: "farming",
    },
  ],
  download: "dam_detail",
  downloadId: "dam_id",
};

// const YearList = [
//   { value: 'سال گذشته', gainValue: 'cur' },
//   { value: 'سال جاری', gainValue: 'pre' },
// ];

// const ItemList = [
//   { value: 'واقعی', gainValue: 'real' },
//   { value: 'برنامه بودجه', gainValue: 'program' },
//   { value: 'پیش بینی آینده', gainValue: 'forecast' },
// ];

const DamChart = () => {
  const [chartData, setChartData] = useState({});
  const [value, setValue] = useState(
    thisPageData.options[thisPageData.options.length - 1].gainValue
  );
  const token = useSelector((state) => state.auth.Token);
  const location = useLocation();
  const [Range, setRange] = useState(1);
  const [Start, setStart] = useState(moment());
  const [End, setEnd] = useState(moment());
  const { isLoadingAsync, finalData, clearAsync, NewRequest, Key } = useAsync({
    Key: 1,
    reqData: {
      chart: {
        url: `chart/dam-latest/?range=${Range}&dam_id=${location.state.id}`,
        method: "GET",
        header: { Authorization: `Bearer ${token}` },
      },
    },
  });
  const [historyRange, setHistoryRange] = useState({
    program: [],
    forecast: [],
  });

  const [AllChartData, setAllChartData] = useState({});
  const [Color, setColor] = useState("#9fa8da");
  const [Last, setLast] = useState();
  const [isLoading, setIsLoading] = useState();
  const [open, setOpen] = useState(false);
  const [compareData, setCompareData] = useState({
    realprogram: {
      drinking: [],
      farming: [],
      industrial: [],
      other: [],
      year: [],
    },
    program: { drinking: [], farming: [], industrial: [], other: [] },
    realforecast: {
      drinking: [],
      farming: [],
      industrial: [],
      other: [],
      year: [],
    },
    forecast: { drinking: [], farming: [], industrial: [], other: [] },
  });
  const [selectedType, setSelectedType] = useState(typeCompare.programCompare);

  console.log(selectedType);

  const handleOpenModal = (e) => {
    setSelectedType(typeCompare[e.target.name]);
    setOpen(true);
  };

  const chartRef = useRef(null);

  useEffect(() => {
    const colors = {};
    thisPageData.options.forEach((element) => {
      colors[element.gainValue] = element.color;
    });
    setColor(colors);

    console.log(colors);
  }, [setColor]);

  useEffect(() => {
    console.log(Color);
  }, [Color]);

  useEffect(() => {
    console.log(finalData);
    if (!finalData || !Key || Key === "loading") {
      return;
    }

    if (AllChartData[Key]) {
      return;
    }

    const { chart } = finalData;

    if (chart && !chart.error && chart.real.length > 0) {
      const allChartData = { labels: [] };
      const allOptions = thisPageData.options;

      allOptions.map((e) => {
        allChartData[e.gainValue] = [];
        return 0;
      });

      let date;
      chart.real.forEach((CD) => {
        date = moment(CD.date).format("jYYYY-jMM-jDD");
        allChartData.labels.push(date);
        allOptions.forEach((e) => {
          allChartData[e.gainValue].push({ y: CD[e.gainValue], x: date });
        });
      });

      const reversed = {};

      for (const key in allChartData) {
        reversed[key] = allChartData[key].reverse();
      }

      console.log(reversed);
      setAllChartData((pre) => {
        const p = { ...pre };
        p[Key] = reversed;
        return p;
      });

      setLast(chart.latest_update);

      setChartData({
        data: {
          datasets: [
            {
              pointHoverRadius: 5,
              pointHitRadius: 30,
              tension: 0.4,
              fill: false,
              cubicInterpolationMode: "monotone",
              parsing: false,
            },
          ],
        },
        options: {
          animation: false,
          normalized: true,
          spanGaps: true,
          // showLine: false,
          datasets: {
            line: {
              pointRadius: 0, // disable for all `'line'` datasets
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            yAxes: {
              title: {
                display: true,
                text: "yAxisTitle",
                font: {
                  size: 15,
                },
              },
            },
            xAxes: {
              x: {
                type: "time",
                time: {
                  unit: "month",
                },
              },
              title: {
                display: true,
                text: "زمان",
                font: {
                  size: 15,
                  family: "IRANSansWeb",
                  weight: "bold",
                },
              },
              ticks: {
                maxTicksLimit: 12,
              },
            },
          },
        },
      });
    }

    clearAsync();
  }, [finalData, setAllChartData, setChartData, clearAsync, AllChartData, Key]);

  // const download = useCallback(() => {
  //   fetch(chartRef.current.toBase64Image(), {
  //     method: 'GET',
  //     headers: {},
  //   })
  //     .then((response) => {
  //       response.arrayBuffer().then(function (buffer) {
  //         const url = window.URL.createObjectURL(new Blob([buffer]));
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.setAttribute('download', `${value}.png`);
  //         document.body.appendChild(link);
  //         link.click();
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, [chartRef, value]);

  const chart = useMemo(() => {
    if (chartData) {
      let dt = null;
      if (chartData.data && chartData.data.datasets[0].data) {
        dt = chartData;
      }

      return dt && <Line ref={chartRef} {...dt} />;
    }
  }, [chartData, chartRef]);

  useEffect(() => {
    if (value && AllChartData[Range]) {
      setChartData(
        (pre) =>
          pre &&
          Object.keys(pre).length && {
            ...pre,
            data: {
              labels: AllChartData[Range].labels,
              datasets: [
                {
                  ...pre.data.datasets[0],
                  label: value,
                  data: AllChartData[Range][value],
                  // backgroundColor: `rgba(${Color[value]}, 0.4)`,
                  backgroundColor: `rgb(${Color[value]})`,
                  borderColor: `rgb(${Color[value]})`,
                },
              ],
            },
            options: {
              ...pre.options,
              scales: {
                ...pre.options.scales,
                yAxes: {
                  title: {
                    ...pre.options.scales.yAxes.title,
                    text: lbDic[value],
                    font: {
                      size: 15,
                      family: "IRANSansWeb",
                      weight: "bold",
                    },
                  },
                },
              },
            },
          }
      );
    }
  }, [value, setChartData, AllChartData, Color, Range]);

  useEffect(() => console.log(Range), [Range]);

  useEffect(() => {
    if (!AllChartData[Range] && Range !== 1) {
      NewRequest({
        NewKey: Range,
        NewReqData: {
          chart: {
            url: `chart/dam-latest/?range=${Range}&dam_id=${location.state.id}`,
            method: "GET",
            header: { Authorization: `Bearer ${token}` },
          },
        },
      });
    }
  }, [NewRequest, Range, AllChartData, location, token]);

  const navigation = useMemo(() => {
    return (
      <div className="center">
        <span onClick={() => setRange((pre) => pre + 1)}>
          <Icon
            path={mdiPageLast}
            title="NEXT"
            size={1}
            style={{ visibility: !Range ? "hidden" : "visible" }}
          />
        </span>
        <span>{Range}</span>
        <span onClick={() => setRange((pre) => (pre === 1 ? 1 : pre - 1))}>
          <Icon
            path={mdiPageFirst}
            title="PREVIOUS"
            size={1}
            style={{ visibility: Range === 1 ? "hidden" : "visible" }}
          />
        </span>
      </div>
    );
  }, [Range, setRange]);

  // const downloadChart = useMemo(() => {
  //   return (
  //     <div className='chartDownload' style={{ justifyContent: 'center', marginBottom: '0' }}>
  //       <button onClick={download}>
  //         دریافت نمودار <Icon path={mdiCloudUploadOutline} size={1} />
  //       </button>
  //     </div>
  //   );
  // }, [download]);

  const downloadCSV = useCallback(() => {
    if (Start.format("YYYY-MM-DD") === End.format("YYYY-MM-DD")) {
      return;
    }

    setIsLoading(true);
    fetch(
      `http://213.233.177.17:8022/download/${thisPageData.download}?${
        thisPageData.downloadId
      }=${location.state.id}&start_date=${Start.format(
        "YYYY-MM-DD"
      )}&end_date=${End.format("YYYY-MM-DD")}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        response.headers.forEach((value, name) => {
          console.log(name + ": " + value);
        });

        return response.blob().then((data) => {
          const the = response.headers.get("Content-disposition");
          const thea = the.slice(the.indexOf('"') + 1, the.length - 1);
          console.log(the);
          console.log(thea);

          return {
            blob: data,
            fileName: thea,
          };
        });
      })
      .then(({ blob, fileName }) => {
        console.log(fileName);

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again)
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  }, [token, location, Start, End, setIsLoading]);

  const downloadUI = useMemo(() => {
    if (location.state.id && thisPageData.download) {
      return (
        <div className="chartDownload">
          <CInput
            config={{
              type: "calendar",
              placeholder: "تاریخ شروع",
            }}
            value={Start}
            direction="rtl"
            changed={setStart}
          />
          <CInput
            config={{
              type: "calendar",
              placeholder: "تاریخ پایان",
            }}
            value={End}
            direction="rtl"
            changed={setEnd}
          />
          <button onClick={downloadCSV}>
            دریافت داده ها به فرمت CSV
            <Icon path={mdiCloudUploadOutline} size={1} />
          </button>
          {value !== "volume_current_year" &&
          value !== "water_supplied_volume_current_year" &&
          value !== "input_current_year" ? (
            <>
              <button name="programCompare" onClick={handleOpenModal}>
                مقایسه با برنامه
                <Compare />
              </button>
              <button name="forecastCompare" onClick={handleOpenModal}>
                مقایسه با پیش بینی
                <Compare />
              </button>
            </>
          ) : null}
        </div>
      );
    } else return null;
  }, [downloadCSV, Start, End, setStart, setEnd, location, value]);

  return (
    <SpinnerHandler isLoading={isLoadingAsync || isLoading}>
      <Helmet>
        <title>نمودار سدها</title>
      </Helmet>
      <Header />
      <CompareChart
        setHistoryRange={setHistoryRange}
        historyRange={historyRange}
        setCompareData={setCompareData}
        selectedType={selectedType}
        options={thisPageData.options}
        value={value}
        open={open}
        setOpen={setOpen}
        id={location.state.id}
        compareData={compareData}
      />
      <div className="chartInfo">
        <h2>
          {thisPageData.title} {location.state.name}
        </h2>

        {thisPageData.options && (
          <Select
            value={value}
            setValue={setValue}
            list={thisPageData.options}
            Color={Color[value]}
            last={Last}
          />
        )}
      </div>

      <div className="center damChart">
        {navigation}
        <div>{chart}</div>
      </div>

      {/* {downloadChart} */}
      {downloadUI}
      <Footer />
    </SpinnerHandler>
  );
};

export default DamChart;
